module.exports = async function fetchAnonymousContent(
	url,
	method = "GET",
	body = null,
	headers = null,
	agent = null,
	returnResponse = false
) {
	const isFormData = body instanceof FormData;

	if (body && !isFormData && !(body instanceof File)) {
		body = JSON.stringify(body);
	}

	var init = {
		method: method,
		headers: {},
	};

	if (!isFormData) {
		init.headers["Content-Type"] = "application/vnd.api+json";
	}

	if (agent) {
		init.agent = agent;
	}
	Object.assign(init.headers, headers);

	if (body) {
		init.body = body;
	}
	if (returnResponse) {
		return fetch(url, init)
			.then((response) => {
				return response;
			})
			.catch(function (err) {
				console.error(err.message);
			});
	} else {
		return fetch(url, init)
			.then((response) => {
				if (response.ok) {
					return response.json();
				} else {
					console.warn(response.status + "  " + url);
				}
			})
			.then((response) => {
				if (response && response.data) {
					return response;
				}
			})
			.catch(function (err) {
				console.error(err);
			});
	}
};
